import { Box, HStack, IconButton, Notice, Text, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { ScrollView } from 'native-base';
import React from 'react';

import { ReportGeneratorListItemNormalized } from '../../../../../store/reportGenerator/types';
import { StatusBadge } from '../../MainReportGenerator/DocumentsTable/shared/row/StatusBadge';

import { DetailsField } from './DetailsField';

interface DetailsModalContentProps {
  item: ReportGeneratorListItemNormalized;
  onDismiss: () => void;
}

const SectionTitle: React.FC<{ children: string }> = ({ children }) => (
  <Text
    variant="bold"
    fontSize={Typography['fontsize.lg']}
    color="brand.primary.principal"
    lineHeight="distant">
    {children}
  </Text>
);

export const DetailsModalContent: React.FC<DetailsModalContentProps> = ({ item, onDismiss }) => {
  const sectionTitle =
    item.subCategoryLabel && item.subCategoryLabel !== '--'
      ? item.subCategoryLabel
      : item.documentTypeLabel;

  return (
    <ScrollView showsVerticalScrollIndicator={false} w="full" flex={1} minH={0}>
      <VStack w="full" p={Spacing['inset.sm']} space={Spacing['stack.xxs']}>
        <HStack
          w="full"
          alignItems="center"
          justifyContent="space-between"
          space={Spacing['inline.nano']}>
          <Text
            variant="bold"
            fontSize={Typography['fontsize.lg']}
            color="neutral.black"
            lineHeight="distant"
            flex={1}>
            Detalhes do Relatório
          </Text>
          <IconButton
            testId="report-generator-details-modal-close"
            icon="CloseModal"
            iconSize="xs"
            borderWidth="1"
            variant="rounded"
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            borderColor={Color['brand.primary.principal']}
            onPress={onDismiss}
            p={0}
          />
        </HStack>

        <Notice
          type="alert"
          testID="report-generator-details-beta-notice"
          backgroundColor="#DBEAFF73"
          fontSize="14px"
          textObjects={[
            { text: <Text>Versão Beta: </Text>, variant: 'semibold' },
            {
              text: <Text>Você está gerando o novo relatório, disponível em versão Beta.</Text>,
              variant: 'regular',
            },
          ]}
        />

        <SectionTitle>{sectionTitle}</SectionTitle>

        <DetailsField
          label="Status"
          value={
            <StatusBadge
              status={item.status}
              normalizedError={item.normalizedError}
              bgColor={item.statusIcon.bgColor}
              color={item.statusIcon.color}
            />
          }
          testID="report-generator-details-status"
        />
        <DetailsField
          label="Categoria"
          value={item.categoryLabel}
          testID="report-generator-details-category"
        />
        <DetailsField
          label="Tipo de Documento"
          value={item.documentTypeLabel}
          testID="report-generator-details-document-type"
        />
        <DetailsField
          label="Solicitado em"
          value={item.requestedAtDetailed}
          testID="report-generator-details-requested-at"
        />

        <Box w="full" h="1px" bg="neutral.lightest" />

        <SectionTitle>Parâmetros da Solicitação</SectionTitle>
        <DetailsField
          label="Tipo do Período"
          value={item.periodTypeLabel}
          testID="report-generator-details-period-type"
        />
        <DetailsField
          label="Período Selecionado"
          value={item.selectedPeriodDisplay}
          testID="report-generator-details-period-value"
        />
        {item.detailParameters.map((parameter) => (
          <DetailsField
            key={`${parameter.label}-${parameter.value}`}
            label={parameter.label}
            value={parameter.value}
            testID={`report-generator-details-param-${parameter.label}`}
          />
        ))}
      </VStack>
    </ScrollView>
  );
};
